import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Form, Formik } from 'formik';
import { useAddMediaPrice } from 'entities/media/media-price';
import { useSnack } from 'shared/ui/snack';
import { CompanyMediaAttachForm, companyMediaAttachEmptyValues, CompanyMediaAttachFormValues, validateCompanyMediaAttach } from './company-media-attach-dialog.form';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';

export const CompanyMediaAttachDialog = ({ open, companyId, onClose }: { open: boolean; companyId: number; onClose: () => void }) => {
  const { showError, showSuccess } = useSnack();
  const addMediaPrice = useAddMediaPrice();

  const handleSubmit = async (values: CompanyMediaAttachFormValues) => {
    try {
      const mediaId = values.mediaId;
      if (!mediaId) throw new Error('Не выбрано СМИ');

      await addMediaPrice({
        media: Number(mediaId),
        companies: String(companyId),
        mainFile: values.mainFile[0],
        extraFiles: values.extraFiles,
      });

      showSuccess('СМИ прикреплено к поставщику');
      onClose();
    } catch (e: unknown) {
      showError(extractNestJsErrorMessage(e) || 'Ошибка прикрепления СМИ');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Прикрепить СМИ к поставщику</DialogTitle>
      <DialogContent dividers>
        <Formik initialValues={companyMediaAttachEmptyValues} validate={validateCompanyMediaAttach} onSubmit={handleSubmit}>
          {(formikProps) => (
            <Form>
              <CompanyMediaAttachForm companyId={companyId} onClose={onClose} />
              <DialogActions sx={{ px: 0, pt: 2 }}>
                <Button variant="contained" onClick={() => formikProps.submitForm()} disabled={formikProps.isSubmitting}>
                  {formikProps.isSubmitting ? 'Подождите…' : 'Прикрепить'}
                </Button>
                <Button variant="outlined" onClick={onClose} disabled={formikProps.isSubmitting}>
                  Закрыть
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};
